export interface DeviceConfig5Message {
  locationNamePart2: string
}

export function decodeDeviceConfig5(data: Uint8Array): DeviceConfig5Message {
  const locationNamePart2 = new TextDecoder().decode(data).split('\u0000')[0]

  return {
    locationNamePart2,
  }
}
